import { styled } from "goober";
import type { Protocol } from "./constants";

export const PROTOCOL_LABELS: Record<Protocol, string> = {
  oidc: "OpenID Connect",
  saml: "SAML 2.0",
};

export const SsoModalForm = styled("form")`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
